import { useState } from 'react';
import { Badge, Col, Container, Row } from 'react-bootstrap';

import { SearchInput, Select, SelectedInterestsRow, SelectedInterestsContainer } from '@/components';

export const Interests = () => {
	const [selectedInterests] = useState([
		{
			title: 'Research',
			category: 'Content Type',
			priority: 'HIGH',
		},
		{
			title: 'Technology',
			category: 'Topic',
			priority: 'MEDIUM',
		},
		{
			title: 'Supplier Management',
			category: 'Business Process',
			priority: 'MEDIUM',
		},
	]);

	const [searchValue, setSearchValue] = useState('');
	const [filterValue, setFilterValue] = useState('');

	return (
		<Container className="py-6">
			<Row className="mb-6">
				<Col>
					<h1 className="mb-1">Interests</h1>
					<p className="mb-0">
						We’ll prioritize recommending content related to the interests selected below.
					</p>
				</Col>
			</Row>
			<Row className="mb-13">
				<Col>
					<h2 className="mb-3">Selected</h2>
					<SelectedInterestsContainer>
						{selectedInterests.map((selectedInterest, index) => {
							return (
								<SelectedInterestsRow
									key={index}
									title={selectedInterest.title}
									onRemoveButtonClick={() => {
										// TODO: Submit this on change? Submit with a button? Will have to ask designer.
										return;
									}}
									category={selectedInterest.category}
									priority={selectedInterest.priority}
									onPriorityChange={() => {
										// TODO: Submit this on change? Submit with a button? Will have to ask designer.
										return;
									}}
								/>
							);
						})}
					</SelectedInterestsContainer>
				</Col>
			</Row>
			<Row className="mb-6">
				<Col>
					<div className="d-flex align-items-center justify-content-between">
						<h2 className="mb-3">Available</h2>
						<div className="d-flex align-items-center">
							<SearchInput
								className="mr-3"
								value={searchValue}
								onChange={(event) => {
									setSearchValue(event.currentTarget.value);
								}}
							/>
							<Select
								value={filterValue}
								onChange={(event) => {
									setFilterValue(event.currentTarget.value);
								}}
								required
							>
								<option value="" disabled>
									Filter
								</option>
								<option value="OPTION_1">Option 1</option>
								<option value="OPTION_2">Option 2</option>
								<option value="OPTION_3">Option 3</option>
							</Select>
						</div>
					</div>
				</Col>
			</Row>
			<Row>
				<Col>
					<Badge className="mr-2 mb-2" bg="primary" pill>
						Research
					</Badge>
					<Badge className="mr-2 mb-2" bg="primary" pill>
						Best Practices
					</Badge>
					<Badge className="mr-2 mb-2" bg="primary" pill>
						Benchmark Metrics
					</Badge>
					<Badge className="mr-2 mb-2" bg="primary" pill>
						Strategy and Organization
					</Badge>
					<Badge className="mr-2 mb-2" bg="primary" pill>
						Talent
					</Badge>
					<Badge className="mr-2 mb-2" bg="primary" pill>
						Agility
					</Badge>
					<Badge className="mr-2 mb-2" bg="primary" pill>
						Sourcing and Supply Base Strategy
					</Badge>
					<Badge className="mr-2 mb-2" bg="primary" pill>
						Supply Chain
					</Badge>
					<Badge className="mr-2 mb-2" bg="primary" pill>
						Purchasing Options
					</Badge>
					<Badge className="mr-2 mb-2" bg="primary" pill>
						Technology
					</Badge>
					<Badge className="mr-2 mb-2" bg="primary" pill>
						Digital Transformation
					</Badge>
					<Badge className="mr-2 mb-2" bg="primary" pill>
						Performance and Value Measurement
					</Badge>
					<Badge className="mr-2 mb-2" bg="primary" pill>
						Customer Management
					</Badge>
					<Badge className="mr-2 mb-2" bg="primary" pill>
						Sourcing Execution
					</Badge>
					<Badge className="mr-2 mb-2" bg="primary" pill>
						Supplier Partnering
					</Badge>
					<Badge className="mr-2 mb-2" bg="primary" pill>
						Research
					</Badge>
					<Badge className="mr-2 mb-2" bg="primary" pill>
						Best Practices
					</Badge>
					<Badge className="mr-2 mb-2" bg="primary" pill>
						Benchmark Metrics
					</Badge>
					<Badge className="mr-2 mb-2" bg="primary" pill>
						Strategy and Organization
					</Badge>
					<Badge className="mr-2 mb-2" bg="primary" pill>
						Talent
					</Badge>
					<Badge className="mr-2 mb-2" bg="primary" pill>
						Agility
					</Badge>
					<Badge className="mr-2 mb-2" bg="primary" pill>
						Sourcing and Supply Base Strategy
					</Badge>
					<Badge className="mr-2 mb-2" bg="primary" pill>
						Supply Chain
					</Badge>
					<Badge className="mr-2 mb-2" bg="primary" pill>
						Purchasing Options
					</Badge>
					<Badge className="mr-2 mb-2" bg="primary" pill>
						Technology
					</Badge>
					<Badge className="mr-2 mb-2" bg="primary" pill>
						Digital Transformation
					</Badge>
				</Col>
			</Row>
		</Container>
	);
};
